import React, { useState } from 'react';
import NavSubBar from '../NavBarElementsDropdown/NavSubBar';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import BoutonDark from '../DarkMode/BoutonDark';

const NavbarAuth = ({ textButton, link }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed bg-white md:bg-transparent px-4 md:px-[20px] py-2 w-full z-50 shadow-md md:shadow-none">
      <div className="flex justify-between items-center">
        <a href="/">
          <img
            src="/Logo NextMaker.png"
            alt="logo"
            className="h-[35px] block"
          />
        </a>

        <div className="hidden md:flex items-center space-x-5">
          <div>
            <NavSubBar textColor="text-dark-1" />
          </div>
          <a href={link}>
            <button className='border border-red-4 text-white hover:bg-transparent
          bg-red-4 hover:text-red-4 transition-colors duration-300
          dark:hover:bg-light-2 dark:hover:text-red-4
          text-sm px-6 md:px-9 py-2 rounded-full'>
              {textButton}
            </button>
          </a>
        </div>

        <button
          className="md:hidden text-dark-1"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? (
            <XMarkIcon className="h-6 w-6" />
          ) : (
            <Bars3Icon className="h-6 w-6" />
          )}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white py-4 px-2 mt-4 rounded-lg shadow-xl">
          <NavSubBar mobile />
          <a href={link}>
            <button className='w-full mt-4 border border-dark-1 text-white hover:bg-transparent
          dark:hover:bg-light-2 dark:hover:text-dark-1
          bg-dark-1 hover:text-dark-1 transition-colors duration-300
          text-sm px-9 py-2 rounded-full'>
              {textButton}
            </button>
          </a>
        </div>
      )}
    </nav>
  );
};

export default NavbarAuth;